const SHADOW_CSS = `
:host {
  display: block;
  width: 100%;
  min-height: 0;
}
:host, .am-shell {
  box-sizing: border-box;
}
.am-shell {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  max-height: 320px;
  min-height: 0;
  font:
    normal 400 12px / 1.25 system-ui,
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    sans-serif;
  color: #1f2937;
}
.am-alert {
  flex-shrink: 0;
  margin: 0 0 0.3rem;
  padding: 0.25rem 0.4rem;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
  background: #fef2f2;
  color: #991b1b;
  border: 1px solid #fecaca;
}
.am-lines {
  display: flex;
  flex-direction: column;
  gap: 0.22rem;
  flex: 1 1 auto;
  align-self: stretch;
  width: 100%;
  min-height: 0;
  overflow-x: hidden;
}
.am-lines-sticky-head {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-self: stretch;
  width: 100%;
}
.am-lines-scroll {
  display: flex;
  flex-direction: column;
  gap: 0.22rem;
  flex: 1 1 auto;
  align-self: stretch;
  width: 100%;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}
.am-placeholder {
  margin: 0;
  opacity: 0.65;
  font-size: 11px;
}
.am-line {
  padding: 0.4rem 0.42rem 0.38rem;
  border-radius: 5px;
  border: 1px solid #94a3b8;
  background: #fafafa;
}
.am-line--split-top {
  border-radius: 5px 5px 0 0;
  border-bottom: none;
  margin-bottom: 0;
  padding-top: 0.42rem;
}
.am-line--split-bottom {
  border-radius: 0 0 5px 5px;
  border-top: none;
  margin-top: -1px;
  padding-top: 0.34rem;
  padding-bottom: 0.42rem;
}
.am-line--split-bottom .am-line-details {
  margin-top: 0;
}
.am-line--green {
  border-color: #22c55e;
  background: #f0fdf4;
}
.am-line--blue {
  border-color: #3b82f6;
  background: #eff6ff;
}
.am-line--yellow {
  border-color: #eab308;
  background: #fefce8;
}
.am-line--red {
  border-color: #ef4444;
  background: #fef2f2;
}
.am-line-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.25rem;
  min-width: 0;
}
.am-line-title-row {
  display: flex;
  align-items: baseline;
  gap: 0.28rem;
  min-width: 0;
  flex: 1;
}
.am-line-name {
  flex: 0 1 auto;
  font-weight: 600;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.am-line-actions {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  flex-shrink: 0;
  min-width: 0;
}
.am-line-badge {
  font-size: 10px;
  font-weight: 700;
  min-width: 1.1rem;
  min-height: 1.1rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0 0.28rem;
  border-radius: 999px;
  background: #0f172a;
  color: #fff;
  flex-shrink: 0;
}
.am-line-expand-btn {
  flex-shrink: 0;
  box-sizing: border-box;
  width: 1.35rem;
  height: 1.35rem;
  padding: 0;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  background: #fff;
  color: #475569;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
}
.am-line-expand-btn:hover {
  background: #f8fafc;
}
.am-line-expand-btn:focus-visible {
  outline: 1px solid #3b82f6;
  outline-offset: 1px;
}
.am-line-expand-btn--open {
  background: #f0f9ff;
  border-color: #7dd3fc;
}
.am-line-expand-btn--open svg {
  transform: rotate(180deg);
}
.am-line-expand-btn svg {
  transition: transform 0.15s ease;
}
.am-accordion-chevron {
  display: block;
}
.am-line--green .am-line-badge {
  background: #166534;
}
.am-line--blue .am-line-badge {
  background: #1d4ed8;
}
.am-line--yellow .am-line-badge {
  background: #a16207;
}
.am-line--red .am-line-badge {
  background: #b91c1c;
}
.am-line-details {
  display: flex;
  flex-direction: column;
  gap: 0.18rem;
  margin: 0.2rem 0 0;
  padding: 0;
  overflow: visible;
}
.am-line-call-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  gap: 0.16rem 0.26rem;
  font-size: 10px;
  line-height: 1.35;
  font-weight: 500;
  overflow: visible;
}
.am-line-call-row--sess-blue {
  box-sizing: border-box;
  padding: 0.06rem 0;
  margin: 0;
  border-radius: 0;
  background: transparent;
  color: #1e40af;
}
.am-line-call-row--sess-yellow {
  box-sizing: border-box;
  padding: 0.06rem 0;
  margin: 0;
  border-radius: 0;
  background: transparent;
  color: #854d0e;
}
.am-line-call-row--sess-red {
  box-sizing: border-box;
  padding: 0.06rem 0;
  margin: 0;
  border-radius: 0;
  background: transparent;
  color: #991b1b;
}
.am-line-call-row--sess-green {
  box-sizing: border-box;
  padding: 0.06rem 0;
  margin: 0;
  border-radius: 0;
  background: transparent;
  color: #166534;
}
.am-call-time {
  font-variant-numeric: tabular-nums;
  opacity: 0.82;
  font-size: 9px;
  white-space: nowrap;
}
.am-call-duration {
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  font-size: 10px;
  white-space: nowrap;
}
.am-call-dir {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  align-self: center;
  min-width: 1.65rem;
  padding: 0 0.22rem;
  margin: 0;
  border-radius: 4px;
  border: 1px solid transparent;
  font-weight: 800;
  font-family:
    ui-monospace,
    "Cascadia Code",
    "Segoe UI Mono",
    Consolas,
    monospace;
  font-size: 10px;
  line-height: 1.2;
  letter-spacing: 0;
  user-select: none;
  white-space: nowrap;
  overflow: visible;
}
.am-call-dir--inbound {
  color: #065f46 !important;
  background: #d1fae5;
  border-color: #34d399;
}
.am-call-dir--outbound {
  color: #1d4ed8 !important;
  background: #dbeafe;
  border-color: #60a5fa;
}
.am-call-dir--unknown {
  color: #475569 !important;
  background: #f1f5f9;
  border-color: #cbd5e1;
}
.am-call-num {
  font-weight: 600;
  white-space: nowrap;
  word-break: normal;
  min-width: 0;
}
.am-call-user {
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 9rem;
}
.am-line-digits {
  flex: 0 1 auto;
  font-size: 11px;
  font-weight: 500;
  opacity: 0.75;
  white-space: nowrap;
}
.am-debug {
  flex-shrink: 0;
  margin-top: 0.45rem;
  max-height: 5rem;
  min-height: 0;
  overflow-y: auto;
  font-size: 10px;
  border-top: 1px dashed #cbd5e1;
  padding-top: 0.35rem;
}
.am-debug-line {
  margin: 0 0 0.25rem;
  white-space: pre-wrap;
  word-break: break-word;
}

`.trim();

export function attachShadowCss(root: ShadowRoot): void {
  const sheet = document.createElement("style");
  sheet.textContent = SHADOW_CSS;
  root.prepend(sheet);
}
